<template>
<span>
  <!-- <span class="igt-icon" :class="[{'background': background}, {'img': mode === 'img'}, 'color-'.concat(colorName), {'count': count > 0}]">
    <img v-if="mode === 'img'" class="img" :src="name" alt="Icon">
    <span v-if="mode === 'css'" class="css" :class="className" :style="styleObject"></span>
    <badge v-if="count > 0" :class="[{'small' : moreThanHundredLiveEvents}]">{{count}}</badge>
  </span> -->
  <span class="pd-icon" :class="'pd-'+className"></span>
</span>
</template>

<script>
import Badge from '@/components/common/Badge'

export default {
  name: 'Icon',

  components: {
    Badge
  },

  data () {
    return {
    }
  },
  mixins: [
  ],
  props: {
    mode: {
      type: String,
      default: 'css'
    },

    name: {
      type: String,
      default: ''
    },

    background: {
      type: Boolean,
      default: false
    },

    colorName: {
      type: String,
      default: 'dark'
    },

    count: {
      type: Number,
      default: 0
    },

    isFromSiteNavigation: {
      type: Boolean
    }
  },

  computed: {
    className () {
      return this.isClass(this.name) ? this.name.toLowerCase() : ''
    },

    styleObject () {
      return this.isClass(this.name) ? {} : {backgroundImage: 'url("' + this.name + '")'}
    },

    moreThanHundredLiveEvents () {
      if (this.isFromSiteNavigation && this.count >= 100) {
        return true
      } else return false
    }
  },

  methods: {
    isClass (value) {
      return value.indexOf('icon-') === 0
    }
  },

  created () {

  }
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/common/Icon.vue